(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.EventsSummary.DinnerSeminars",
                    {
                        url: "/DinnerSeminars",
                        component: "dinnerseminarsNew",
                        PageTitle: "Dinner Seminars | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("dinnerseminarsNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/EventsSummary/DinnerSeminars/dinnerseminars-new-template.html",
                controller: dinnerSeminarsNewController,
                bindings: {
                    summaryYear: "<",
                    user: "<",
                    onGetUserEvents: "&",
                    onGetUserEventExport: "&",
                    selectedEventType: "<"
                }
            });

    dinnerSeminarsNewController.$inject = ["userApi", "_", "$filter", "moment", "featureToggleService", "amplitudeService"];
    function dinnerSeminarsNewController(userApi, _, $filter, moment, featureToggleService, amplitudeService) {
        var $ctrl = this;

        $ctrl.ui = {
            downloadingExport: false
        };

        // set event table defaults
        $ctrl.eventTable = {
            events: []
        };

        $ctrl.populatePageData = function () {

            // stat normalization
            var calculateStat = function (number, allowNegative, decimals) {
               
                var roundToPrecision = function (x, precision) {
                    var power = Math.pow(10, precision);
                    var rounded = Math.round(power * x);
                    return (rounded / power);
                };

                // round to the hundredth decimal
                var value = roundToPrecision(number, 2);              
             
                // if greater than 1 and no decimals defined, round to the nearest integer
                if (value > 1 && (!decimals || decimals === 0)) {
                    return Math.round(value);
                }

                if (allowNegative) {
                    return value;
                }
                else if (value < 0) {
                    return 0;
                }

                
                return value;
            };

            // data aggregate default
            var newDataAggregate = function () {
                return {
                    referrals: 0,
                    clients: 0,
                    prospects: 0,
                    total: 0
                };
            };

            // reset data
            $ctrl.data = {
                invites: 0,
                totalInsuranceBusinessClosed: 0,
                totalSpent: 0,
                totalCommissions: 0,
                appointmentsKept: newDataAggregate(),
                appointmentsSet: newDataAggregate(),
                appointmentsClosed: newDataAggregate(),
                unitsAttended: newDataAggregate(),
                attendees: newDataAggregate(),
                reservations: newDataAggregate(),
                // reset stats
                stats: {
                    responseRate: {
                        value: 0,
                        standard: function (val) {
                            if (val >= .4) // upper 1%
                                return true;
                            return false;
                        },
                        standardDisplay: "0.4% - 1%"
                    },
                    noShowRate: {
                        value: 0,
                        standard: function (val) {
                            if (val <= 20) // lower 15%
                                return true;
                            return false;
                        },
                        standardDisplay: "15% - 20%"
                    },
                    appointmentSetRate: {
                        value: 0,
                        standard: function (val) {
                            if (val >= 50)
                                return true;
                            return false;
                        },
                        standardDisplay: "50%"
                    },
                    persistencyRate: {
                        value: 0,
                        standard: function (val) {
                            if (val >= 90)
                                return true;
                            return false;
                        },
                        standardDisplay: "90%"
                    },
                    closeRate: {
                        value: 0,
                        standard: function (val) {
                            if (val >= 30)
                                return true;
                            return false;
                        },
                        standardDisplay: "30%"
                    },
                    roi: {
                        value: 0,
                        standard: function(val) {
                            if (val >= 73)
                                return true;
                            return false;
                        },
                        standardDisplay: "73%"
                    },
                    averageCaseSize: {
                        value: 0,
                        standard: function(val) {
                            if (val >= 150000)
                                return true;
                            return false;
                        },
                        standardDisplay: "$150,000"
                    }
                }
            };

            // reset overview
            $ctrl.overview = {
                insuranceBusinessClosed: 0,
                totalSpent: 0,
                totalCommissions: 0,
                roi: 0
            };

            // new performance item
            var newPerformanceItem = function (name, displayName, icon, value, valueDisplay) {
                $ctrl.performanceTimeline.push({
                    name: displayName,
                    icon: icon,
                    value: value,
                    display: valueDisplay,
                    isGood: $ctrl.data.stats[name].standard(value),
                    standard: $ctrl.data.stats[name].standardDisplay
                });
            };

            // reset performance timeline
            $ctrl.performanceTimeline = [];

            // new event item
            var newEventItem = function (e) {               
                $ctrl.eventTable.events.push({
                    groupId: e.Id,
                    id: e.EventId,
                    title: e.EventTitle,
                    type: e.EventType.Name,
                    date: moment(e.EventDate),
                    totalSpent: e.TotalEventCost,
                    totalInsuranceBusinessClosed: e.TotalInsuranceBusinessClosed,
                    totalCommission: e.TotalCommission,
                    responseRate: e.ResponseRate,
                    noShowRate: e.NoShowRate,
                    appointmentSetRate: e.AppointmentSetRate,
                    persistencyRate: e.PersistencyRate,
                    closeRate: e.CloseRate,
                    averageCaseSize: e.AverageCaseSize
                });
            };

            // reset event table
            $ctrl.eventTable.events = [];

            // populate data
            userApi.getFigAuth($ctrl.user.Id).then(function (figAuthUser) {
                $ctrl.user.figAuthId = figAuthUser.FigAuthUserId;
                $ctrl.onGetUserEvents({
                    figAuthUserId: figAuthUser.FigAuthUserId
                }).then(function (groups) {                   
                    var data = $ctrl.data;                
                    data.collection = groups;

                    // parse event group function
                    var parseEventGroup = function (e) {

                        // apply event aggregate to data aggregate function
                        var applyToAggregate = function (agg, eventAgg) {
                            agg.referrals += eventAgg.Referrals;
                            agg.clients += eventAgg.Clients;
                            agg.prospects += eventAgg.Prospects;
                            agg.total += (eventAgg.Referrals + eventAgg.Clients + eventAgg.Prospects);
                        };

                        // increment totals
                        data.invites += e.Invites;
                        data.totalCommissions += e.TotalCommission;
                        data.totalSpent += e.TotalEventCost;
                        data.totalInsuranceBusinessClosed += e.TotalInsuranceBusinessClosed;

                        // apply aggregate
                        //if (e.CommunicationMedium === 'Live' || !e.CommunicationMedium)  //only calculate those with EventMedium as 'Live'; 'Webinars' TBD -Removing check for now per Monica B
                        //{
                            if (e.AppointmentsKept) {
                                applyToAggregate(data.appointmentsKept, e.AppointmentsKept);
                            }

                            if (e.AppointmentsSet) {
                                applyToAggregate(data.appointmentsSet, e.AppointmentsSet);
                            }

                            if (e.AppointmentsClosed) {
                                applyToAggregate(data.appointmentsClosed, e.AppointmentsClosed);
                            }

                            if (e.UnitsAttended) {
                                applyToAggregate(data.unitsAttended, e.UnitsAttended);
                            }

                            if (e.Attendees) {
                                applyToAggregate(data.attendees, e.Attendees);
                            }

                            if (e.Reservations) {
                                applyToAggregate(data.reservations, e.Reservations);
                            }
                        //}                        
                    };

                    // iterate event groups
                    ng.forEach(_.uniqBy(groups, function(row) { return row.Id; }),
                        function(g) {
                            parseEventGroup(g);
                        });

                    // iterate events
                    ng.forEach(_.uniqBy(groups, function (row) { return row.Id + ":" + row.EventId; }),
                        function (e) {
                            newEventItem(e);
                        });

                    // response rate                   
                    data.stats.responseRate.value = data.invites > 0
                        ? calculateStat((data.reservations.prospects / data.invites) * 100, false, 2)
                        : 0;
                  
                    newPerformanceItem("responseRate", "Response<br/>Rate", "fig-mailbox-open", data.stats.responseRate.value, (data.stats.responseRate.value + "%"));

                    // no show rate
                    data.stats.noShowRate.value = data.reservations.total > 0
                        ? calculateStat(((data.reservations.total - data.attendees.total) / data.reservations.total) * 100, false, 0)
                        : 0;

                    newPerformanceItem("noShowRate", "No-show<br/>Rate", "fig-cancel", data.stats.noShowRate.value, (data.stats.noShowRate.value + "%"));

                    // appointment set rate
                    data.stats.appointmentSetRate.value = (data.unitsAttended.total > 0 && data.appointmentsSet.total > 0)
                        ? calculateStat((data.appointmentsSet.total / data.unitsAttended.total) * 100, false, 0)
                        : 0;

                    newPerformanceItem("appointmentSetRate", "Appointment Set<br/>Rate", "fig-calendar-check", data.stats.appointmentSetRate.value, (data.stats.appointmentSetRate.value + "%"));

                    // persistency rate
                    data.stats.persistencyRate.value = (data.appointmentsSet.total > 0 && data.appointmentsKept.total > 0)
                        ? calculateStat((data.appointmentsKept.total / data.appointmentsSet.total) * 100, false, 0)
                        : 0;

                    newPerformanceItem("persistencyRate", "Persistency<br/>Rate", "fig-calendar", data.stats.persistencyRate.value, (data.stats.persistencyRate.value + "%"));

                    // close rate
                    data.stats.closeRate.value = (data.appointmentsKept.total > 0 && data.appointmentsClosed.total > 0)
                        ? calculateStat((data.appointmentsClosed.total / data.appointmentsKept.total) * 100, false, 0)
                        : 0;

                    newPerformanceItem("closeRate", "Close<br/>Rate", "fig-thumb-up", data.stats.closeRate.value, (data.stats.closeRate.value + "%"));

                    // return on investment
                    data.stats.roi.value = data.totalSpent > 0
                        ? calculateStat(((data.totalCommissions - data.totalSpent) / data.totalSpent) * 100, true, 0)
                        : 0;

                    // total average case size
                    data.stats.averageCaseSize.value = (data.totalInsuranceBusinessClosed > 0 && data.appointmentsClosed.total > 0)
                        ? (data.totalInsuranceBusinessClosed / data.appointmentsClosed.total)
                        : 0;

                    newPerformanceItem("averageCaseSize", "Average Case<br/>Size", "fig-briefcase", data.stats.averageCaseSize.value, $filter("currency")(data.stats.averageCaseSize.value, "$", 2));

                    // set overview
                    $ctrl.eventTable.events = $ctrl.eventTable.events.concat();
                    $ctrl.overview.insuranceBusinessClosed = data.totalInsuranceBusinessClosed;
                    $ctrl.overview.totalSpent = data.totalSpent;
                    $ctrl.overview.totalCommissions = data.totalCommissions;
                    $ctrl.overview.roi = data.stats.roi.value;
                });
            });
        };

        $ctrl.downloadUserEventExport = function () {

            $ctrl.ui.downloadingExport = true;
            $ctrl.onGetUserEventExport({
                figAuthUserId: $ctrl.user.figAuthId
            }).then(
                function (response) {
                    var startDate = moment(new Date($ctrl.summaryYear, 0, 1)).format("MMDDYYYY");
                    var endDate = moment(new Date($ctrl.summaryYear + 1, 0, 1)).format("MMDDYYYY");
                    var fileName = "DinnerSeminarSummary_" + startDate + "-" + endDate + ".xlsx";

                    // link to file
                    var f = document.createElement("a");
                    f.style = "display: none";
                    document.body.appendChild(f);

                    var fUrl = window.URL.createObjectURL(response);
                    f.href = fUrl;
                    f.download = fileName;
                    f.click();

                    setTimeout(function () {
                        document.body.removeChild(f);
                        window.URL.revokeObjectURL(fUrl);
                    }, 100);

                    // log event
                    amplitudeService.logCustomEvent("Dinner Seminars Export", fileName, {
                        file_name: fileName,
                        file_type: response.type,
                        file_size: response.size
                    });
                })
                .finally(function() {
                    $ctrl.ui.downloadingExport = false;
                });
        };

        $ctrl.$onChanges = function (changes) {
            if (changes.selectedEventType) {
                if (typeof changes.selectedEventType.previousValue === "string") {
                    $ctrl.populatePageData();
                }
            }
        };
    }

})(window.app, window.angular); //jshint ignore:line